import React from "react"
import { Box, HStack } from "@chakra-ui/react"
import ColorCircle from "components/ReactHookForm/ColorSelect/ColorCircle"

export const SEGMENT_COLORS = [
  "gray", "red", "orange", "yellow", "green",
  "teal", "blue", "cyan", "purple", "pink",
] as const

export type SegmentColor = typeof SEGMENT_COLORS[number]

type Props = {
  value: string
  onChange: (color: string) => void
}

const SegmentColorPicker = ({ value, onChange }: Props) => (
  <HStack spacing={2}>
    {SEGMENT_COLORS.map((c) => (
      <Box key={c} flexShrink={0}>
        <ColorCircle
          color={`${c}.400`}
          selected={value === c}
          onSelect={() => onChange(c)}
        />
      </Box>
    ))}
  </HStack>
)

export default SegmentColorPicker
